import { useMemo } from 'react';
import { useGetSinglePage } from 'react-easyrocket';
import { CmsContent } from 'src/components/CmsContent';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { Skeletons } from '../Skeletons';

const VipRulesModal = () => {
  const { data, isFetched } = useGetSinglePage('loyalty_rules');
  const rules = useMemo(() => data?.childs?.find((child) => child.code === 'loyalty_main'), [data]);
  return (
    <ModalWrapper>
      <div className="flex flex-col items-center gap-5 p-[15px] 568:w-[400px] w-full h-full">
        {!isFetched ? (
          <Skeletons count={1} className="h-[900px] min-w-[300px] w-full" />
        ) : (
          rules && (
            <>
              <p className="text-vrm_title text-[26px] font-bold text-center">{rules?.title}</p>
              <CmsContent content={rules?.content} className="text-vrm_text pb-6 cms-dropdown" />
            </>
          )
        )}
      </div>
    </ModalWrapper>
  );
};

// eslint-disable-next-line no-restricted-exports
export default VipRulesModal;
